import { PREVIEW } from "../apiConstant";
import BaseApi from "../baseApi";

class PreviewApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_AUTHENTICATION_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  getLinkPreview(body) {
    return this.post(`${PREVIEW}/link`, body);
  }

  fetchExcelPreview(param, signal) {
    return this.post(`${PREVIEW}/excel`, param, signal);
  }

  fetchTextPreview(body, signal) {
    return this.post(`${PREVIEW}/text`, body, signal);
  }

  fetchPdfPreview(body, signal) {
    return this.post(`${PREVIEW}/pdf`, body, {
      signal: signal,
      responseType: "blob",
    });
  }
}
export default PreviewApi;
